import {PostRequest} from "@configs/request";
import ObjectToFromData from "../utils/ObjectToFormData";
import {store} from "@store/storeConfig/store";
import {handleLogin} from "../../redux/actions/auth";

const Ping = () => {
    let token = localStorage.getItem('token');
    PostRequest('/ping', ObjectToFromData({'token': token}), {'Authorization': token})
        .then((response) => {
            if (response) {
                let result = response.data;
                if (result.ok && result.data) {
                    result = result.data;
                    store.dispatch(handleLogin(result));
                }
            }
        })
}
export default Ping
